import CurrentBalanceContext from "src/context/CurrentBalanceContext";
import { useContext } from "react";

const useBalance = () => useContext(CurrentBalanceContext);

export default useBalance;
